import {BIRTH, DEATH, IDENTIFICATION, ADDRESS_PROOF, WEDDING, REFERENCE, CNN} from '@/constants/TypeOfCertificates';
import Vue from 'vue';
import i18n from '@/i18n';
const vue = new Vue({i18n});

export const NORMAL = 'NORMAL';
export const RELIGIOUS = 'RELIGIOUS';
export const CIVIL = 'CIVIL';
export const BAPTISM = 'BAPTISM';
export const BAPTISM_NEGATIVE = 'BAPTISM_NEGATIVE';
export const NEGATIVE = 'NEGATIVE';
export const NONEXISTENT = 'NONEXISTENT';
export const LIVES = 'LIVES';
export const NOT_OFFICIAL = 'NOT_OFFICIAL';
export const STABLE_UNION = 'STABLE_UNION';
export const RG = 'RG';
export const PASSPORT = 'PASSPORT';
export const ADDRESS_PROOF_OWN = 'ADDRESS_PROOF_OWN';
export const ADDRESS_PROOF_ADDRESS = 'ADDRESS_PROOF_ADDRESS';
export const ADDRESS_PROOF_FATHER = 'ADDRESS_PROOF_FATHER';
export const ADDRESS_PROOF_MOTHER = 'ADDRESS_PROOF_MOTHER';
export const ADDRESS_PROOF_WIFE = 'ADDRESS_PROOF_WIFE';
export const ADDRESS_PROOF_HUSBAND = 'ADDRESS_PROOF_HUSBAND';

const TYPE_OF_DOCUMENTS_FOR_BIRTH = [
    {id: BAPTISM, name: vue.$t('enumerations.type-of-documents.baptism')},
    {id: BAPTISM_NEGATIVE, name: vue.$t('enumerations.type-of-documents.baptismNegative')},
    {id: CIVIL, name: vue.$t('enumerations.type-of-documents.civil')},
    {id: NEGATIVE, name: vue.$t('enumerations.type-of-documents.negative')},
];

const TYPE_OF_DOCUMENTS_FOR_WEDDING = [
    {id: CIVIL, name: vue.$t('enumerations.type-of-documents.civil')},
    {id: NEGATIVE, name: vue.$t('enumerations.type-of-documents.negative')},
    {id: NONEXISTENT, name: vue.$t('enumerations.type-of-documents.nonexistent')},
    {id: NOT_OFFICIAL, name: vue.$t('enumerations.type-of-documents.not_official')},
    {id: RELIGIOUS, name: vue.$t('enumerations.type-of-documents.religious')},
    {id: STABLE_UNION, name: vue.$t('enumerations.type-of-documents.stable_union')},
];

const TYPE_OF_DOCUMENTS_FOR_DEATH = [
    {id: NORMAL, name: vue.$t('enumerations.type-of-documents.normal')},
    {id: RELIGIOUS, name: vue.$t('enumerations.type-of-documents.religious')},
    {id: NEGATIVE, name: vue.$t('enumerations.type-of-documents.negative')},
    {id: NONEXISTENT, name: vue.$t('enumerations.type-of-documents.nonexistent')},
    {id: LIVES, name: vue.$t('enumerations.type-of-documents.lives')},
];

const TYPE_OF_DOCUMENTS_FOR_IDENTIFICATION = [
    {id: RG, name: vue.$t('enumerations.type-of-documents.rg')},
    {id: PASSPORT, name: vue.$t('enumerations.type-of-documents.passport')},
];

const TYPE_OF_DOCUMENTS_FOR_ADDRESS_PROOF = [
    {id: ADDRESS_PROOF_OWN, name: vue.$t('enumerations.type-of-documents.address_proof_own')},
    {id: ADDRESS_PROOF_ADDRESS, name: vue.$t('enumerations.type-of-documents.address_proof_address')},
    {id: ADDRESS_PROOF_FATHER, name: vue.$t('enumerations.type-of-documents.address_proof_father')},
    {id: ADDRESS_PROOF_MOTHER, name: vue.$t('enumerations.type-of-documents.address_proof_mother')},
    {id: ADDRESS_PROOF_WIFE, name: vue.$t('enumerations.type-of-documents.address_proof_wife')},
    {id: ADDRESS_PROOF_HUSBAND, name: vue.$t('enumerations.type-of-documents.address_proof_husband')},
];

const TYPE_OF_DOCUMENTS_FOR_REFERENCE = [
    {id: NORMAL, name: vue.$t('enumerations.type-of-documents.normal')},
];

const CNN_TYPE_OF_DOCUMENTS = [
    {id: NORMAL, name: vue.$t('enumerations.type-of-documents.normal')},
];

export const _getTypeOfDocuments = (typeCertificate) => {
    switch (typeCertificate) {
        case BIRTH : return TYPE_OF_DOCUMENTS_FOR_BIRTH;
        case WEDDING : return TYPE_OF_DOCUMENTS_FOR_WEDDING;
        case DEATH : return TYPE_OF_DOCUMENTS_FOR_DEATH;
        case IDENTIFICATION: return TYPE_OF_DOCUMENTS_FOR_IDENTIFICATION;
        case ADDRESS_PROOF: return TYPE_OF_DOCUMENTS_FOR_ADDRESS_PROOF;
        case REFERENCE: return TYPE_OF_DOCUMENTS_FOR_REFERENCE;
        case CNN: return CNN_TYPE_OF_DOCUMENTS;
    }
}
